import type { ThemeValueLegacy } from '@elfsight/configurator-controls';

// TODO: move these values to widget form builder
export const themeMapping = ({ type, accentColor }: ThemeValueLegacy) => {
  switch (type) {
    case 'dark':
      return {
        fieldActiveColor: accentColor,
        fieldFillColor: 'rgba(255, 255, 255, 0.2)',
        fieldBorderColor: 'rgba(255, 255, 255, 0.2)',
        fieldLabelColor: 'rgb(255, 255, 255)',
        fieldColor: 'rgb(255, 255, 255)',
        fieldHintColor: 'rgba(255, 255, 255, 0.5)',
        submitMessageTitleColor: 'rgb(255, 255, 255)',
        submitMessageTextColor: 'rgba(255, 255, 255, 0.5)',
        widgetFooterTextColor: 'rgba(255, 255, 255, 0.5)',
        widgetFooterLinksColor: accentColor
      };
    case 'light':
      return {
        fieldActiveColor: accentColor,
        fieldFillColor: 'rgba(17, 17, 17, 0.1)',
        fieldBorderColor: 'rgba(17, 17, 17, 0.2)',
        fieldLabelColor: 'rgb(17, 17, 17)',
        fieldColor: 'rgb(17, 17, 17)',
        fieldHintColor: 'rgba(17, 17, 17, 0.5)',
        submitMessageTitleColor: 'rgb(17, 17, 17)',
        submitMessageTextColor: 'rgba(17, 17, 17, 0.5)',
        widgetFooterTextColor: 'rgba(17, 17, 17, 0.5)',
        widgetFooterLinksColor: accentColor
      };
    default:
      throw new Error(`Unknown theme type ${type}`);
  }
};
